export function limiter<T>(
  demo: boolean,
  limit: number,
): (items: ReadonlyArray<T>) => ReadonlyArray<T> {
  return demo ? (items) => items.slice(0, limit) : (items) => items;
}
